<template>
<div :data-testid="`modal-${modalId}`" :id="modalId" class="overlay" @click="handleClose">
  <div class="modal" @click.stop>
    <header class="modal-header">
      <h2 class="info-section-subheading">{{heading}}</h2>
    </header>
    <div class="modal-body">
      <slot />
    </div>
    <footer v-if="showFooter">
      <div class="button-holder">
        <button
          class="elr-button elr-button-primary"
          @click="handleConfirm"
        >{{confirmationText}}</button>
        <button
          class="elr-button elr-button-danger"
          @click="handleCancel"
        >{{cancellationText}}</button>
      </div>
    </footer>
  </div>
</div>
</template>

<script>
export default {
  name: 'ModalWindow',
  props: {
    showFooter: {
      type: Boolean,
      default: false,
    },
    modalId: {
      type: String,
      required: true
    },
    heading: {
      type: String,
      required: true
    },
    confirmationText: {
      type: String,
      default: 'Confirm'
    },
    cancellationText: {
      type: String,
      default: 'Cancel'
    }
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleConfirm() {
      this.$emit('confirm');
    },
    handleCancel() {
      this.$emit('cancel');
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/sass/_config.scss';

.overlay {
  background-color: rgba($text-color, .8);
  position: fixed;
  z-index: 20;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal {
  background-color: #fff;
  width: 80vw;
  max-width: 800px;
  height: 80vh;
  overflow-x: hidden;
  overflow-y: scroll;
  border-radius: 5px;
  box-shadow: $shadow;
  padding: 15px;

  h2 {
    font-weight: 900;
    color: $text-color;
    padding: 10px 0;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 10px;
    border-bottom: 1px solid $light-grey;
  }

  .button-holder {
    padding: 20px;
    text-align: left;

    .elr-button {
      margin-right: 20px;
    }
  }
}
</style>


